import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  pl: {
    translation: {
      "app": {
        "title": "Insulimit | osłodź zdrowie",
        "description": "Przejmij kontrolę nad cukrzycą z Insulimit - inteligentną aplikacją mobilną do śledzenia poziomu cukru we krwi, leków i diety. Dbaj o swoje zdrowie dzięki intuicyjnym wnioskom, przypomnieniom i spersonalizowanej analizie. Zacznij zarządzać cukrzycą z łatwością już dziś!",
      },
      // Menu
      "About us": "O nas",
      "Terms of Service": "Regulamin",
      "Privacy Policy": "Polityka Prywatności",
      "Health Information": "Informacje Zdrowotne",
      "Contact": "Kontakt",
      "Dark mode": "Tryb ciemny",
      "Light mode": "Tryb jasny",
      "Main Page": "Strona główna",

      "Remove account form": "Formularz usuwania konta",
      "accountDeletionDisclaimer": "Aby usunąć konto na zawsze, wprowadź adres email powiązany z kontem, na który wyślemy wiadomość z kodem PIN.",
      "Send email": "Wyślij email",
      "Delete account": "Usuń konto",
      "Account successfully deleted": "Konto zostało usunięte pomyślnie",
      "Failed to delete account": "Nie udało się usunąć konta",

      // Welcome bar
      "Sweeten your health": "Osłodź swoje zdrowie",
      "If you can't measure it, you can't improve it.": "Jeśli nie możesz czegoś zmierzyć, nie możesz tego poprawić.",
      "Get on Google Play": "Pobierz z Google Play",
      "Get on App Store": "Pobierz z App Store",

      // App shots
      "App screen": "Ekran aplikacji",

      // Cookies
      "cookies": {
        "title": "Informacje o plikach cookie",
        "message": "Ta strona używa plików cookie w celu dostarczenia funkcjonalności.",
        "close": "Zamknij"
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  // lng: "en",
  lng: "pl",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
